/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { connect } from 'react-redux';
import { formatDateForInput } from 'utilities/common';
import { formatMoney } from 'utilities/currencyFormatter';
import { useMoneyInputs } from 'modules/common/useMoneyInputs';
import { makeStyles } from '@material-ui/styles';
import { showToast } from 'modules/layout/layout.actions';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Spinner from './spinner.component';
import classNames from 'classnames';

import AdvancedSearch from 'modules/common/advancedSearch.component';
import GoogleAddressSearch from './googleAddressSearch.component';
import { calculateTripDuration } from 'modules/authorizations/utils';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import { RENTAL_CAR_CLASS_IDS, ZERO_GUID } from 'modules/enumerations/enumerationIds';

const useStyles = makeStyles(theme => ({
  card: {
    width: '100%',
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  chip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  chipClickable: {
    cursor: 'pointer'
  },
  iconOverlayImg: {
    position: 'absolute',
    zIndex: '1 !important'
  },
  spacingX: {
    marginRight: theme.spacing(1)
  },
  footer: {
    height: 15,
    marginBottom: theme.spacing(2)
  },
  mb2: {
    marginBottom: '4px',
    marginRight: '16px'
  },
  editModalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100% !important',
    marginLeft: '0px !important'
  },
  editModalColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100% !important'
  },
  editModalInput: {
    minWidth: '332px'
  },
  dialogContentContainer: {
    margin: '15px'
  },
  labelText: {
    minWidth: 350,
    marginBottom: 0
  }
}));

const CreateTripCard = props => {
  const {
    isLoading,
    smallerModal,
    onSubmit,
    onDelete,
    setDataState, //To be used with useEffect in parent for dynamically rendering summaries.
    dataState,
    enumerations,
    addresses,
    familyMembers,
    trips,
    location,
    defaultCategory,
    isReadOnly,
    currentTripId,
    setCurrentTripId,
    formatTripListAddress,
    maxNumTrips = null,
    tripCapAmount = null
  } = props;
  const classes = useStyles();

  const filteredAddresses = addresses.filter(s => s.excludeAddressFromSelection === false);

  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  const [showAddTrip, setShowAddTrip] = useState(false);

  // const [currentTripId, setCurrentTripId] = useState(
  //     trips && trips[0]
  //     ? trips[0].tripId
  //     : null
  // );
  const trip = trips ? trips.find(s => s.tripId === currentTripId) : null;

  let family =
    familyMembers && Array.isArray(familyMembers)
      ? familyMembers.map(f => {
        return f.firstName + ' ' + f.lastName;
      })
      : [];

  const tripTypes = ['One Way', 'Round-Trip'];
  const tripCategories =
    enumerations.tripCategories && enumerations.tripCategories.length > 0
      ? enumerations.tripCategories.filter(s => s.isActive === true)
      : [{ id: ZERO_GUID, title: '' }];

  const tripBooking = ['Self Booked', 'TRC Booking'];

  const rentalCarClassOptions =
    enumerations.rentalCarClasses && enumerations.rentalCarClasses.length > 0
      ? enumerations.rentalCarClasses
      : [{ id: ZERO_GUID, title: '' }];

  //   const parseValueToArray = input => {
  //     if (!input) return [];
  //     return Array.isArray(input) ? input : input.split(',');
  //   };

  const categories = [
    { id: 0, title: 'tripSummary' },
    { id: 1, title: 'airTransport' },
    { id: 2, title: 'hotelBooking' },
    { id: 3, title: 'rentalCar' }
  ];

  const tripSummaries = [
    {
      header: 'Trip Title',
      accessorKey: 'tripName',
      type: 'text',
      required: false,
      //   value: trip ? trip.tripName : '',
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Trip Category',
      accessorKey: 'tripCategoryId',
      type: 'dropdown-v2',
      options: tripCategories,
      //   value: trip?.tripCategory ? trip.tripCategory : '644f419f-072d-49ad-a86c-58052b45175c',
      required: true,
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Family Attending',
      accessorKey: 'familyAttending',
      type: 'multi-select',
      options: family,
      required: false,
      //   hasDefault: true,
      //   defaultValue: ({ values }) => {
      //     return values && values.familyAttending && values.familyAttending.length > 0
      //       ? parseValueToArray(values.familyAttending)
      //       : parseValueToArray(family[0])
      //   },
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Journey',
      accessorKey: 'typeOfTrip',
      type: 'dropdown',
      options: tripTypes,
      //   value: trip?.typeOfTrip ? trip.typeOfTrip : tripTypes[1],
      required: true,
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Origin',
      accessorKey: 'departureAddressId',
      type: 'dropdown-v2',
      options: filteredAddresses && filteredAddresses.length > 0 ? filteredAddresses : [],
      required: true,
      categoryType: 'tripSummary',
      //   value: trip ? trip.departureAddressId : null,
      tab: 1
    },
    {
      header: 'Destination',
      accessorKey: 'destinationAddressId',
      type: 'dropdown-v2',
      options: filteredAddresses && filteredAddresses.length > 0 ? filteredAddresses : [],
      required: true,
      categoryType: 'tripSummary',
      //   value: trip ? trip.destinationAddressId : null,
      tab: 1
    },
    {
      header: 'Trip Start Date',
      accessorKey: 'tripStartDate',
      type: 'date',
      required: false,
      //   value: trip ? trip.tripStartDate : null,
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Trip End Date',
      accessorKey: 'tripEndDate',
      type: 'date',
      required: false,
      //   value: trip ? trip.tripEndDate : null,
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Total Nights',
      accessorKey: 'tripDuration',
      type: 'number',
      required: false,
      hasDefault: true,
      defaultValue: ({ values }) => {
        return values.tripStartDate && values.tripEndDate
          ? calculateTripDuration(values.tripStartDate, values.tripEndDate, 0)
          : 0;
      },
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Special Needs',
      accessorKey: 'specialNeeds',
      type: 'notes',
      required: false,
      //   value: trip ? trip.specialNeeds : '',
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Notes',
      accessorKey: 'notes',
      type: 'notes',
      required: false,
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Booking Type',
      accessorKey: 'hasBookingDetails',
      type: 'dropdown',
      options: tripBooking,
      //   value: trip?.hasBookingDetails ? tripBooking[1] : tripBooking[0],
      required: true,
      categoryType: 'tripSummary',
      tab: 1
    },
    // Air Transport
    {
      header: 'Air Transport',
      accessorKey: 'airTransport',
      type: 'checkbox',
      required: false,
      //   value: trip ? trip.airTransport : false,
      tab: 1,
      categoryType: 'airTransport',
      Cell: ({ cell }) => <Checkbox name="airTransport" label="Active" checked={cell.row.original.airTransport} disabled={true} />,
      showWhen: () => {
        return trip && trip.hasBookingDetails === tripBooking[1];
      },
      showWhenModal: ({ values }) => {
        return values && values.hasBookingDetails === tripBooking[1];
      }
    },
    {
      header: 'Departure Date',
      accessorKey: 'airTransportDepartureDate',
      type: 'date',
      required: false,
      //   value: trip ? trip.airTransportDepartureDate : null,
      categoryType: 'airTransport',
      tab: 1,
      showWhen: () => {
        return trip && trip.airTransport === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.airTransport === true;
      }
    },
    {
      header: 'Arrival Date',
      accessorKey: 'airTransportArrivalDate',
      type: 'date',
      required: false,
      //   value: trip ? trip.airTransportArrivalDate : null,
      categoryType: 'airTransport',
      tab: 1,
      showWhen: () => {
        return trip && trip.airTransport === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.airTransport === true;
      }
    },
    {
      header: 'Return Departure Date',
      accessorKey: 'airTransportReturnDepartureDate',
      type: 'date',
      required: false,
      //   value: trip ? trip.airTransportReturnDepartureDate : null,
      categoryType: 'airTransport',
      dependentOn: 'typeOfTrip',
      dependentValue: 'Round-Trip',
      tab: 1,
      showWhen: () => {
        return trip && trip.airTransport === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.airTransport === true;
      }
    },
    {
      header: 'Return Arrival Date',
      accessorKey: 'airTransportReturnArrivalDate',
      type: 'date',
      required: false,
      //   value: trip ? trip.airTransportReturnArrivalDate : null,
      dependentOn: 'typeOfTrip',
      dependentValue: 'Round-Trip',
      categoryType: 'airTransport',
      tab: 1,
      showWhen: () => {
        return trip && trip.airTransport === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.airTransport === true;
      }
    },
    // Hotel Booking
    {
      header: 'Hotel Booking',
      accessorKey: 'hotelBooking',
      type: 'checkbox',
      required: false,
      //   value: trip ? trip.hotelBooking : false,
      categoryType: 'hotelBooking',
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="hotelBooking" label="Active" checked={cell.row.original.hotelBooking} disabled={true} />,
      showWhen: () => {
        return trip && trip.hasBookingDetails === tripBooking[1];
      },
      showWhenModal: ({ values }) => {
        return values && values.hasBookingDetails === tripBooking[1];
      }
    },
    {
      header: 'Hotel Name',
      accessorKey: 'hotelName',
      type: 'text',
      required: false,
      //   value: trip ? trip.hotelName : '',
      categoryType: 'hotelBooking',
      tab: 1,
      showWhen: () => {
        return trip && trip.hotelBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hotelBooking === true;
      }
    },
    {
      header: 'Hotel Address',
      accessorKey: 'hotelAddressId',
      type: 'dropdown-v2',
      options: filteredAddresses && filteredAddresses.length > 0 ? filteredAddresses : [],
      required: false,
      categoryType: 'hotelBooking',
      //   value: trip ? trip.hotelAddressId : null,
      tab: 1,
      showWhen: () => {
        return trip && trip.hotelBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hotelBooking === true;
      }
    },
    {
      header: 'Check In',
      accessorKey: 'hotelCheckInDate',
      type: 'date',
      required: false,
      //   value: trip ? trip.hotelCheckInDate : null,
      categoryType: 'hotelBooking',
      tab: 1,
      showWhen: () => {
        return trip && trip.hotelBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hotelBooking === true;
      }
    },
    {
      header: 'Check Out',
      accessorKey: 'hotelCheckOutDate',
      type: 'date',
      required: false,
      //   value: trip ? trip.hotelCheckOutDate : null,
      categoryType: 'hotelBooking',
      tab: 1,
      showWhen: () => {
        return trip && trip.hotelBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hotelBooking === true;
      }
    },
    {
      header: 'Duration of Stay',
      accessorKey: 'hotelDurationOfStay',
      type: 'number',
      required: false,
      hasDefault: true,
      defaultValue: ({ values }) => {
        return values && values.hotelCheckInDate && values.hotelCheckOutDate
          ? calculateTripDuration(values.hotelCheckInDate, values.hotelCheckOutDate, 0)
          : 0;
      },
      categoryType: 'hotelBooking',
      tab: 1,
      showWhen: () => {
        return trip && trip.hotelBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.hotelBooking === true;
      }
    },
    // Rental Car
    {
      header: 'Rental Car',
      accessorKey: 'rentalCarBooking',
      type: 'checkbox',
      required: false,
      //   value: trip ? trip.rentalCarBooking : false,
      categoryType: 'rentalCar',
      tab: 1,
      Cell: ({ cell }) => <Checkbox name="rentalCarBooking" label="Active" checked={cell.row.original.rentalCarBooking} disabled={true} />,
      showWhen: () => {
        return trip && trip.hasBookingDetails === tripBooking[1];
      },
      showWhenModal: ({ values }) => {
        return values && values.hasBookingDetails === tripBooking[1];
      }
    },

    {
      header: 'Rental Car Class',
      accessorKey: 'rentalCarClassId',
      type: 'dropdown-v2',
      options: rentalCarClassOptions,
      //   value: trip?.rentalCarClassId ? trip.rentalCarClassId : ZERO_GUID,
      required: true,
      categoryType: 'rentalCar',
      tab: 1,
      showWhen: () => {
        return trip && trip.rentalCarBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.rentalCarBooking === true;
      }
    },
    {
      header: 'Please Specify Rental Car Class',
      accessorKey: 'otherRentalCar',
      type: 'text',
      required: false,
      //   value: trip ? trip.otherRentalCar : '',
      categoryType: 'rentalCar',
      tab: 1,
      clearWhenHidden: true,
      showWhen: () => {
        return trip && trip.rentalCarBooking === true && isIdEqual(trip.rentalCarClassId, RENTAL_CAR_CLASS_IDS.OTHER);
      },
      showWhenModal: ({ values }) => {
        return values && values.rentalCarBooking === true && isIdEqual(values.rentalCarClassId, RENTAL_CAR_CLASS_IDS.OTHER);
      }
    },
    {
      header: 'Rental Car Start Date',
      accessorKey: 'rentalCarStartDate',
      type: 'date',
      required: false,
      //   value: trip ? trip.rentalCarStartDate : null,
      categoryType: 'rentalCar',
      tab: 1,
      showWhen: () => {
        return trip && trip.rentalCarBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.rentalCarBooking === true;
      }
    },
    {
      header: 'Rental Car End Date',
      accessorKey: 'rentalCarEndDate',
      type: 'date',
      required: false,
      //   value: trip ? trip.rentalCarEndDate : null,
      categoryType: 'rentalCar',
      tab: 1,
      showWhen: () => {
        return trip && trip.rentalCarBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.rentalCarBooking === true;
      }
    },
    {
      header: 'Rental Duration',
      accessorKey: 'rentalCarDuration',
      type: 'number',
      required: false,
      hasDefault: true,
      defaultValue: ({ values }) => {
        return values && values.rentalCarStartDate && values.rentalCarEndDate
          ? calculateTripDuration(values.rentalCarStartDate, values.rentalCarEndDate, 0)
          : 0;
      },
      categoryType: 'rentalCar',
      tab: 1,
      showWhen: () => {
        return trip && trip.rentalCarBooking === true;
      },
      showWhenModal: ({ values }) => {
        return values && values.rentalCarBooking === true;
      }
    }
  ];

  return (
    <ThemeProvider theme={theme}>
      <Grid item sx={{ marginBottom: '10px' }}>
        <Paper
          square
          className={classNames('position-fixed', props.classes.headerFixed, props.classes.container)}
          sx={{
            position: 'sticky',
            paddingRight: '10px',
            paddingLeft: '10px',
            marginBottom: '15px',
            minWidth: '100%'
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px' }}>
            <Box>
              <div className={props.classes.mb2}>
                <Typography variant="subtitle2">Trip</Typography>
              </div>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Box>
                  <Paper style={{ minWidth: '300px', maxWidth: '600px', maxHeight: '125px', minHeight: '100px', overflowY: 'scroll' }}>
                    {trips &&
                      trips.map(opt => (
                        <Box
                          sx={{
                            padding: '10px',
                            backgroundColor: currentTripId === opt.tripId ? '#c5e3d3' : undefined,
                            cursor: 'pointer',
                            '&:hover': { backgroundColor: currentTripId === opt.tripId ? '#5D9878' : 'lightgrey' }
                          }}
                          onClick={() => setCurrentTripId(opt.tripId)}
                        >
                          {
                            [
                              opt.tripName,
                              tripCategories.find(category => category.id === opt.tripCategoryId)?.title,
                              `(${new Date(opt.tripStartDate).toLocaleDateString()})`
                            ]
                              .filter(x => x != null && x.length !== 0).join(', ')
                          },{' '}
                          {addresses && addresses.length !== 0 && opt.destinationAddressId
                            ? formatTripListAddress
                              ? formatTripListAddress(addresses.find(a => a.id === opt.destinationAddressId))
                              : addresses.find(a => a.id === opt.destinationAddressId)?.title || ''
                            : ''}
                        </Box>
                      ))}
                  </Paper>
                </Box>
                {location && !location.pathname.includes('expenses') && !isReadOnly && (
                  <>
                    <Button
                      color="secondary"
                      type="submit"
                      variant="contained"
                      sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px' }}
                      onClick={() => setShowAddTrip(true)}
                    >
                      {' '}
                      New Trip{' '}
                    </Button>
                    <Button
                      color="secondary"
                      type="submit"
                      variant="contained"
                      sx={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px', backgroundColor: '#868686' }}
                      onClick={onDelete}
                    >
                      {' '}
                      Delete Trip{' '}
                    </Button>
                  </>
                )}
                {defaultCategory && defaultCategory === '644f419f-072d-49ad-a86c-58052b45175c' && (
                  <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <div className={props.classes.mb2}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '16px', marginLeft: '24px' }}>
                        Trip Cap Amount:{' '}
                      </Typography>
                      <Typography variant="subtitle2" sx={{ color: 'green', fontWeight: 'bold', fontSize: '16px', marginLeft: '24px' }}>
                        {formatMoney(tripCapAmount)}{' '}
                      </Typography>
                    </div>
                    <div className={props.classes.mb2}>
                      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '16px' }}>
                        Max # of Trips:{' '}
                      </Typography>
                      <Typography variant="subtitle2" sx={{ color: 'green', fontWeight: 'bold', fontSize: '16px' }}>
                        {maxNumTrips}
                      </Typography>
                    </div>
                  </Box>
                )}
                {showAddTrip && (
                  <CreateTripModal
                    fieldSummaries={tripSummaries}
                    classes={classes}
                    open={showAddTrip}
                    isLoading={isLoading}
                    onClose={() => setShowAddTrip(false)}
                    onSubmit={onSubmit}
                    smallerModal={smallerModal}
                    setDataState={setDataState}
                    dataState={dataState}
                    categories={categories}
                    defaultCategory={defaultCategory}
                    theme={theme}
                    family={family}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Paper>
      </Grid>
    </ThemeProvider>
  );
};

CreateTripCard.propTypes = {
  enumerations: PropTypes.array.isRequired,
  addresses: PropTypes.array.isRequired,
  showToast: PropTypes.func.isRequired
};
export default connect(null, { showToast })(CreateTripCard);

export const CreateTripModal = ({
  fieldSummaries,
  classes,
  open,
  isLoading,
  onClose,
  onSubmit,
  smallerModal,
  setDataState,
  dataState,
  categories,
  defaultCategory,
  theme,
  family
}) => {
  const moneyInput = useMoneyInputs();
  const [values, setValues] = useState(() => {
    const initialValues = fieldSummaries.reduce((acc, summary) => {
      if (summary.accessorKey === 'familyAttending') {
        acc[summary.accessorKey] = family && family.length > 0 ? [family[0]] : [];
      } else {
        acc[summary.accessorKey ?? ''] = summary.value;
      }
      if (summary.nameKey) acc[summary.nameKey] = summary.nameValue;
      return acc;
    }, {});

    fieldSummaries.filter(summary => summary.hasDefault).forEach(summary => {
      initialValues[summary.accessorKey] = summary.defaultValue({ values: initialValues });
    });

    return initialValues;
  });

  const [isDirty, setIsDirty] = useState(false);

  const checkDirty = (summaries, values) => {
    let dirty = false;
    summaries.map(s => {
      // Checks the datetime cases for equivalence which have inconsistent format
      if (
        typeof s.value === 'string' &&
        typeof values[s.accessorKey] === 'string' &&
        s.value.includes('T00:00:00') &&
        !values[s.accessorKey].includes('T00:00:00')
      ) {
        if (s.value !== `${values[s.accessorKey]}T00:00:00`) dirty = true;
      }
      // Checks case where new and old values are different (ignores case where one is undefined and one is empty string)
      else if (s.value !== values[s.accessorKey] && !(s.value == null && values[s.accessorKey]?.length === 0)) dirty = true;
    });
    setIsDirty(dirty);
  };

  useEffect(() => {
    checkDirty(fieldSummaries, values);
  }, [fieldSummaries, values]);

  // Blanks out any field that opts in with clearWhenHidden once showWhenModal no longer holds, so a field the
  // user can no longer see does not keep submitting the value it had before it was hidden.
  const applyClearRules = nextValues => {
    fieldSummaries
      .filter(summary => summary.clearWhenHidden && typeof summary.showWhenModal === 'function')
      .forEach(summary => {
        if (!summary.showWhenModal({ values: nextValues })) nextValues[summary.accessorKey] = '';
      });

    return nextValues;
  };

  const updateValue = (name, value) => setValues(applyClearRules({ ...values, [name]: value }));

  // Defaulted fields are all date-derived, so they are only recalculated when a date changes - doing it on every
  // edit would overwrite a value the user typed in by hand.
  const updateDateValue = event => {
    const nextValues = { ...values, [event.target.name]: event.target.value };

    fieldSummaries.filter(summary => summary.hasDefault).forEach(summary => {
      nextValues[summary.accessorKey] = summary.defaultValue({ values: nextValues });
    });

    setValues(applyClearRules(nextValues));
  };

  const renderInput = summary => {
    if (summary.type === 'text' && !summary.hideInModal) {
      return (
        <div>
          <TextField
            key={summary.accessorKey}
            label={summary.header}
            name={summary.accessorKey}
            required={summary.required}
            value={values[summary.accessorKey]}
            disabled={summary.disabled}
            margin="dense"
            variant="standard"
            sx={{ maxWidth: '360px' }}
            onChange={e => {
              setValues({ ...values, [e.target.name]: e.target.value });
            }}
          />
          {summary.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (summary.type === 'googleAddressSearch' && !summary.hideInModal) {
      return (
        <div>
          <GoogleAddressSearch
            address={values[summary.accessorKey]}
            countries={summary.countries}
            provinces={summary.provinces}
            classes={classes}
            onChange={e => {
              setValues({ ...values, [summary.accessorKey]: e });
            }}
          />
        </div>
      );
    }
    if (summary.type === 'notes' && !summary.hideInModal) {
      return (
        <div>
          <TextField
            key={summary.accessorKey}
            label={summary.header}
            name={summary.accessorKey}
            required={summary.required}
            value={values[summary.accessorKey]}
            disabled={summary.disabled}
            margin="dense"
            multiline
            variant="standard"
            rows={4}
            sx={{ width: '1100px' }}
            onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
          />
          {summary.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (summary.type === 'number' && !summary.hideInModal) {
      return (
        <div>
          <TextField
            key={summary.accessorKey}
            label={summary.header}
            name={summary.accessorKey}
            required={summary.required}
            value={values[summary.accessorKey]}
            margin="dense"
            disabled={summary.disabled}
            sx={{ maxWidth: '360px' }}
            variant="standard"
            type="number"
            onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
          />
          {summary.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (summary.type === 'decimal' && !summary.hideInModal) {
      return (
        <div>
          <TextField
            key={summary.accessorKey}
            label={summary.header}
            name={summary.accessorKey}
            required={summary.required}
            value={values[summary.accessorKey]}
            margin="dense"
            disabled={summary.disabled}
            sx={{ maxWidth: '360px' }}
            variant="standard"
            type="number"
            allowDecimal={true}
            onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
          />
          {summary.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (summary.type === 'checkbox' && !summary.hideInModal) {
      return (
        <div>
          <FormControl sx={{ marginTop: '20px', marginBottom: '1px' }}>
            <FormControlLabel
              key={summary.accessorKey}
              name={summary.accessorKey}
              label={summary.header}
              labelPlacement="start"
              control={<Checkbox />}
              required={summary.required}
              disabled={summary.disabled}
              checked={values[summary.accessorKey]}
              variant="standard"
              margin="dense"
              sx={{ marginTop: '6px', minWidth: '180px', maxWidth: '360px' }}
              onClick={e => updateValue(e.target.name, e.target.checked)}
            />
          </FormControl>
          {summary.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (summary.type === 'dropdown' && !summary.hideInModal) {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={summary.header}>
              {summary.header}
            </InputLabel>
            <Select
              labelId={summary.header}
              key={summary.accessorKey}
              label={summary.header}
              name={summary.accessorKey}
              required={summary.required}
              disabled={summary.disabled}
              value={values[summary.accessorKey]}
              defaultValue={summary.default}
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
              onChange={e => {
                setValues({ ...values, [e.target.name]: e.target.value });
              }}
            >
              {summary.options.map(opt => (
                <MenuItem key={opt} value={opt} sx={{ margin: 'dense' }}>
                  {opt}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {summary.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (summary.type === 'dropdown-v2' && !summary.hideInModal) {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={summary.header}>
              {summary.header}
            </InputLabel>
            <Select
              labelId={summary.header}
              key={summary.accessorKey}
              label={summary.header}
              name={summary.accessorKey}
              required={summary.required}
              disabled={summary.disabled}
              value={summary.accessorKey === 'tripCategoryId' && defaultCategory ? defaultCategory : values[summary.accessorKey]}
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
              onChange={e => {
                updateValue(e.target.name, e.target.value);
                if (summary.accessorKey === 'saleType') {
                  setDataState({ ...dataState, saleType: e.target.value });
                }
              }}
            >
              {summary && summary.options && summary.options.length > 0 ? (
                summary.options.map(opt => (
                  <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                    {opt.title}
                  </MenuItem>
                ))
              ) : (
                <MenuItem sx={{ margin: 'dense' }}>{'No options available'}</MenuItem>
              )}
            </Select>
          </FormControl>
          {summary.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (summary.type === 'date' && !summary.hideInModal) {
      return (
        <div>
          <TextField
            key={summary.accessorKey}
            label={summary.header}
            name={summary.accessorKey}
            required={summary.required}
            disabled={summary.disabled}
            value={formatDateForInput(values[summary.accessorKey])}
            sx={{ maxWidth: '360px' }}
            margin="dense"
            variant="standard"
            type="date"
            InputLabelProps={{ shrink: true }}
            onChange={updateDateValue}
          />

          {summary.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (summary.type === 'money' && !summary.hideInModal) {
      return (
        <div>
          <TextField
            key={summary.accessorKey}
            label={summary.header}
            name={summary.accessorKey}
            required={summary.required}
            {...moneyInput(summary.accessorKey, values[summary.accessorKey], e =>
              setValues({ ...values, [e.target.name]: e.target.value }),
            )}
            margin="dense"
            disabled={summary.disabled}
            sx={{ maxWidth: '360px' }}
            variant="standard"
            type="number"
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>
            }}
            allowDecimal={true}
          />
          {summary.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (summary.type === 'file' && !summary.hideInModal) {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <TextField
            key={summary.accessorKey}
            name={summary.accessorKey}
            label={summary.header}
            required={summary.required}
            disabled={summary.disabled}
            margin="dense"
            sx={{ maxWidth: '360px' }}
            variant="standard"
            type="file"
            inputProps={{ accept: summary.accept || '*/*' }}
            onChange={e => {
              const file = e.target.files?.[0];
              setValues({
                ...values,
                [e.target.name]: {
                  id: null,
                  file: file || null
                }
              });
            }}
            helperText={values[summary.accessorKey]?.file?.name ? `${values[summary.accessorKey]?.file?.name} Selected` : ''}
            InputLabelProps={{ shrink: true }}
          />
          <button
            type="button"
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: 'red',
              fontSize: '1.2rem'
            }}
            onClick={() =>
              setValues({
                ...values,
                [summary.accessorKey]: { id: null, file: null }
              })
            }
          >
            &#x2715;
          </button>
        </div>
      );
    }
    if (summary.type === 'advanced-search' && !summary.hideInModal) {
      return (
        <AdvancedSearch
          labelText={summary.header}
          displayValueAccessorKey={summary.searchInfo.nameKey}
          saveIdValueAccessorKey={summary.searchInfo.idKey}
          searchingCriteria={summary.searchInfo.searchingColumns}
          searchingCriteriaExtensions={summary.searchInfo.searchingColumnExtensions}
          searchingRows={summary.searchInfo.searchingRows}
          id={values[summary.accessorKey]}
          value={values[summary.nameKey]}
          setIdValue={(id, value) => {
            setValues({ ...values, [summary.nameKey]: value, [summary.accessorKey]: id });
          }}
        />
      );
    }
    if (summary.type === 'multi-select' && !summary.hideInModal) {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={summary.header}>
              {summary.header}
            </InputLabel>
            <Select
              labelId={summary.header}
              key={summary.accessorKey}
              label={summary.header}
              name={summary.accessorKey}
              required={summary.required}
              disabled={summary.disabled}
              value={summary.hasDefault ? summary.defaultValue(values) : values[summary.accessorKey]}
              renderValue={selected => (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '4px'
                  }}
                >
                  {selected.map(value => (
                    <Chip
                      key={value}
                      label={value}
                      onDelete={() => {
                        const updatedValues = values[summary.accessorKey].filter(v => v !== value);
                        setValues({ ...values, [summary.accessorKey]: updatedValues });
                      }}
                      onMouseDown={e => {
                        e.stopPropagation();
                      }}
                    />
                  ))}
                </div>
              )}
              multiple
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '1000px', minWidth: '360px' }}
              onChange={e => setValues({ ...values, [e.target.name]: e.target.value })}
            >
              {summary.options.map(opt => (
                <MenuItem key={opt} value={opt} sx={{ margin: 'dense' }}>
                  {opt}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {summary.required && (
            <>
              <Typography variant="caption" display="block" color="primary">
                Required
              </Typography>
            </>
          )}
        </div>
      );
    }
    if (summary.type === 'multi-select-v2' && !summary.hideInModal) {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={summary.header}>
              {summary.header}
            </InputLabel>
            <Select
              labelId={summary.header}
              key={summary.accessorKey}
              label={summary.header}
              name={summary.accessorKey}
              required={summary.required}
              disabled={summary.disabled}
              value={values[summary.accessorKey] || []}
              multiple
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '1000px', minWidth: '360px' }}
              onChange={e => {
                setValues({
                  ...values,
                  [summary.accessorKey]: e.target.value
                });
              }}
              renderValue={selected => (
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '4px'
                  }}
                >
                  {selected.map(option => (
                    <Chip
                      key={option.id}
                      label={option.title}
                      onDelete={() => {
                        const updatedValues = values[summary.accessorKey].filter(v => v.id !== option.id);
                        setValues({ ...values, [summary.accessorKey]: updatedValues });
                      }}
                      onMouseDown={e => {
                        e.stopPropagation();
                      }}
                    />
                  ))}
                </div>
              )}
            >
              {summary.options.map(opt => (
                <MenuItem key={opt.id} value={opt} sx={{ margin: 'dense' }}>
                  {opt.title} {/* Display name */}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {summary.required && (
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          )}
        </div>
      );
    }
    if (summary.type === 'multi-select-v2-enum' && !summary.hideInModal) {
      return (
        <div>
          <FormControl sx={{ marginTop: '6px' }}>
            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={summary.header}>
              {summary.header}
            </InputLabel>
            <Select
              labelId={summary.header}
              key={summary.accessorKey}
              label={summary.header}
              name={summary.accessorKey}
              required={summary.required}
              disabled={summary.disabled}
              multiple
              margin="dense"
              variant="standard"
              sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '1000px', minWidth: '360px' }}
              value={(values[summary.accessorKey] ?? []).map(x => (typeof x === 'string' ? x : x.id))}
              onChange={e => {
                const selectedIds = e.target.value ?? []; // array of ids
                const dedupedIds = Array.from(new Set(selectedIds));
                setValues({ ...values, [summary.accessorKey]: dedupedIds });
              }}
              renderValue={selectedIds => (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                  {selectedIds.map(id => {
                    const opt = summary.options.find(o => o.id === id);
                    return (
                      <Chip
                        key={id}
                        label={opt?.title ?? id}
                        onDelete={() => {
                          const updated = (values[summary.accessorKey] ?? []).filter(x => x !== id);
                          setValues({ ...values, [summary.accessorKey]: updated });
                        }}
                        onMouseDown={e => e.stopPropagation()}
                      />
                    );
                  })}
                </div>
              )}
            >
              {summary.options.map(opt => (
                <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }}>
                  {opt.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {summary.required && (
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          )}
        </div>
      );
    }
  };

  const handleSubmit = e => {
    //put your validation logic here
    // need to add 'modified on / by' logic here
    e.preventDefault();
    onSubmit(values);
    onClose();
  };

  const handleCancel = e => {
    //put your validation logic here
    e.preventDefault();
    onClose();
  };

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={open} fullWidth={smallerModal ? false : true} maxWidth={'lg'}>
        <form onSubmit={handleSubmit} fullScreen>
          <div className="row justify-space-between align-center">
            <div className={classes.dialogIconRow}>
              {/* {tab.iconPath && (
              <Tooltip title={tab.header} key={tab.header} placement="right">
                <FontAwesomeIcon icon={tab.iconPath} size="3x" />
              </Tooltip>
            )} */}
              <Typography variant="h5" sx={{ paddingLeft: '0px' }}>
                Create Trip
              </Typography>
            </div>
          </div>
          <div className={classes.dialogContentContainer}>
            <Stack
              sx={{
                width: '100%',
                minWidth: { xs: '300px', sm: '360px', md: '400px', lg: '400px' },
                gap: '1.5rem'
              }}
            >
              <Grid container spacing={{ xs: 1, md: 1 }} sx={{ padding: '30px', paddingTop: '0px' }}>
                {(() => {
                  const visibleSummaries = fieldSummaries.filter(s => !s.hideInModal);

                  if (categories && categories.length > 0) {
                    return categories.map(category => {
                      const summariesForCategory = visibleSummaries.filter(s => s.categoryType === category.title);
                      if (summariesForCategory.length === 0) return null;

                      return (
                        <Grid container spacing={{ xs: 1, md: 1 }} sx={{ padding: '30px', paddingTop: '0px' }} key={category.title}>
                          {summariesForCategory.map((opts, idx) => {
                            if (opts.dividerLine) {
                              return (
                                <Box
                                  sx={{ width: '100%', marginTop: '10px', marginBottom: '10px' }}
                                  key={`divider-${opts.accessorKey || idx}`}
                                >
                                  <hr />
                                </Box>
                              );
                            }

                            return (
                              <Grid item key={opts.accessorKey || idx}>
                                {(() => {
                                  const passesShowWhen =
                                    typeof opts.showWhenModal === 'function'
                                      ? !!opts.showWhenModal({ values })
                                      : typeof opts.showWhen === 'function'
                                        ? !!opts.showWhen(values)
                                        : true;

                                  if (!passesShowWhen) return null;

                                  return (
                                    <>
                                      {opts.dependentOn && values[opts.dependentOn] === true && renderInput(opts)}
                                      {!opts.dependentOn && renderInput(opts)}
                                    </>
                                  );
                                })()}
                              </Grid>
                            );
                          })}
                        </Grid>
                      );
                    });
                  }

                  // No categories: render visible summaries in order
                  return visibleSummaries.map((opts, idx) => {
                    if (opts.dividerLine) {
                      return (
                        <Box sx={{ width: '100%', marginTop: '10px', marginBottom: '10px' }} key={`divider-${opts.accessorKey || idx}`}>
                          <hr />
                        </Box>
                      );
                    }

                    return (
                      <Grid item key={opts.accessorKey || idx}>
                        {(() => {
                          const passesShowWhen =
                            typeof opts.showWhenModal === 'function'
                              ? !!opts.showWhenModal({ values })
                              : typeof opts.showWhen === 'function'
                                ? !!opts.showWhen(values)
                                : true;

                          if (!passesShowWhen) return null;

                          return (
                            <>
                              {opts.dependentOn && values[opts.dependentOn] === true && renderInput(opts)}
                              {!opts.dependentOn && renderInput(opts)}
                            </>
                          );
                        })()}
                      </Grid>
                    );
                  });
                })()}
              </Grid>
            </Stack>
          </div>
          {isLoading && (
            <DialogActions sx={{ p: '1.25rem' }}>
              <Spinner />
            </DialogActions>
          )}
          {!isLoading && (
            <DialogActions sx={{ p: '1.25rem' }}>
              <Button onClick={handleCancel}>Cancel</Button>
              <Button color="primary" type="submit" variant="contained" disabled={!isDirty}>
                Save
              </Button>
            </DialogActions>
          )}
        </form>
      </Dialog>
    </ThemeProvider>
  );
};
